import DashboardRedemptionsTable from "./DashboardRedemptionsTable";

export default DashboardRedemptionsTable;
